var exports = {
  "d": "scrollMarksContainer__STmjRv",
};

module.exports = exports;
